<template>
    <CodiceFeanorView tool-module="rainbowTables" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
